import {createEntityAdapter} from '@reduxjs/toolkit'
import {ISpending} from '../../types'

export const spendingsAdapter = createEntityAdapter<ISpending>()